import React, { useState, useEffect } from "react";
import { Anchor, RadioButton } from "hesus-ui-kit";
import { withTranslation } from "react-i18next";
import axios from "axios";
import PropTypes from "prop-types";
import {
  APIErrorMEssage,
  EnquiryTitle,
} from "../../AddEditSellingPrice.styled";
import "./Enquiries.scss";
import { RequiredMessage } from "@utils/extra-style";
import RadioButtonLabel from "@components/RadioButton";

const Enquiries = (props) => {
  const {
    t,
    onSelect,
    requestId,
    isEditMode,
    enquiriesList,
    isJobsite,
    formData,
    siteId,
    countryId,
  } = props;

  const [enquiryTypesAPIError, setEnquiryTypesAPIError] = useState("");
  const [enquiryFilterData, setEnquiryFilterData] = useState();
  const [enquiryList, setEnquiryList] = useState([]);

  const onEnquirySelect = (e) => {
    onSelect(parseInt(e.target.value, 10));
  };

  const enquiryDataRender = (enquiryListRender) => {
    if (requestId || isEditMode) {
      const enquiryData = enquiryListRender[0];
      setEnquiryFilterData(enquiryData);
    } else {
      setEnquiryList(enquiryListRender);
      const enquiryData = enquiryListRender.map((enquiry) => {
        return {
          label: <RadioButtonLabel {...enquiry} />,
          value: enquiry.id,
        };
      });
      setEnquiryFilterData(enquiryData);
    }

    setEnquiryTypesAPIError("");
  };

  useEffect(() => {
    if (enquiriesList && enquiriesList?.id) {
      enquiryDataRender([enquiriesList]);
    } else if (enquiriesList && enquiriesList.length > 0) {
      enquiryDataRender(enquiriesList);
    } else {
      let url = "";

      if (requestId || isEditMode) {
        url = `/enquiries?dataLevel=0&countries=[${countryId}]&requestId=${requestId}&limit=-1&orderBy=asc&orderColumn=id`;
      } else {
        url = `/enquiries?dataLevel=0&step=[1,2,5]&countries=[${countryId}]&siteId=${siteId}&limit=-1&orderBy=asc&orderColumn=id`;
      }
      if (url) {
        axios
          .get(url)
          .then((response) => {
            enquiryDataRender(response.data.enquiries);
          })
          .catch((error) => {
            setEnquiryTypesAPIError(error.response?.data?.message ?? "");
          });
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="enquiry-list">
      {enquiryTypesAPIError !== "" && (
        <APIErrorMEssage>{enquiryTypesAPIError}</APIErrorMEssage>
      )}
      {!isEditMode && isJobsite && enquiryFilterData && (
        <>
          <EnquiryTitle>
            {t("SELLING_PRICE_ENQUIRY_AND_SERVICE_TITLE")}
          </EnquiryTitle>
          <RadioButton
            value={requestId ?? ""}
            onChange={onEnquirySelect}
            name="enquiry-id"
            options={enquiryFilterData}
          />
          {formData.requestId.error && (
            <RequiredMessage margin="-20px 0 0 10px">
              {formData.requestId.error}
            </RequiredMessage>
          )}
        </>
      )}
      {(isEditMode || !isJobsite) && enquiryFilterData && (
        <>
          <EnquiryTitle>
            {t("SELLING_PRICE_ENQUIRY_AND_SERVICE_TITLE")}
          </EnquiryTitle>
          <div>
            <Anchor
              url={`/site/view/${enquiryFilterData.site.id}/enquiry-view-${enquiryFilterData.id}`}
              target="_blank"
              rel="noreferrer"
            >
              [{enquiryFilterData.id}]
            </Anchor>
            &nbsp;&nbsp;
            {t(enquiryFilterData.service)} - {enquiryFilterData.quantity}{" "}
            {t(enquiryFilterData.unit)} - &nbsp;
            {enquiryFilterData.product ? enquiryFilterData.product.name : ""}
          </div>
        </>
      )}
    </div>
  );
};

Enquiries.propTypes = {
  onSelect: PropTypes.func.isRequired,
  requestId: PropTypes.number,
  siteId: PropTypes.number,
  isEditMode: PropTypes.bool,
  t: PropTypes.func.isRequired,
  isJobsite: PropTypes.bool,
};

Enquiries.defaultProps = {
  requestId: null,
  isEditMode: false,
  isJobsite: false,
  siteId: "",
};

export default withTranslation()(Enquiries);
